import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Content as i, DropdownBackground as m } from "./style.js";
function d({
  children: o,
  open: r,
  className: n
}) {
  return /* @__PURE__ */ t(i, { open: r, className: n, children: [
    o,
    /* @__PURE__ */ e(m, {})
  ] });
}
export {
  d as ContentWithOverlay
};
